export const trading = {
    等待确认: 'Đang chờ xác nhận',
    gas矿工费: 'Phí khai thác gas',
    审核扫描: 'Kiểm tra Quét',
    警报: 'Cảnh báo',
    无警报: 'Không cảnh báo',
    显示更多: 'Hiển thị thêm',
    infos: "Những kết quả kiểm toán này được thực hiện tự động bởi các bên ngoại vi của Biking, chúng không phải là đề xuất và cần được xem xét kèm theo các yếu tố khác. Biking không xác minh cũng như không chịu trách nhiệm về chất lượng dữ liệu được thu thập bởi các kiểm toán viên bên ngoại vi này. Luôn tiến hành nghiên cứu của bạn và tham khảo nhiều nguồn thông tin.",
    请输数量: 'Nhập số lượng',
    兑换: 'Đổi',
    价格: 'Giá',
    选择代币: 'Chọn Token',
    搜索名称或粘贴地址: 'Tìm kiếm tên hoặc dán địa chỉ',
    DEXT分数: 'Điểm DEXT',
    更多检测: 'Kiểm tra thêm',
    检查审核: 'Kiểm tra kiểm toán',
    令牌描述: 'Mô tả Token',
    更新: 'Cập nhật',
    合同验证: 'Xác minh hợp đồng',
    买入税: 'Thuế mua',
    代理合同: 'Hợp đồng đại lý',
    可造币: 'Có thể đúc được',
    可修改税收: 'Thuế có thể sửa đổi',
    转让可暂停: 'Chuyển giao có thể tạm dừng',
    黑名单: 'Danh sách đen',
    找回所有权: 'Khôi phục quyền sở hữu',
    可修改余额: 'Số dư có thể sửa đổi',
    隐藏的所有者: 'Chủ sở hữu ẩn',
    自毁: 'Tự hủy',
    外部呼叫风险: 'Rủi ro cuộc gọi từ bên ngoài',
    可以购买: 'Có thể mua',
    最大卖出比率: 'Tỉ lệ bán tối đa',
    白名单: 'Danh sách trắng',
    反鲸鱼可修改: 'Chống cá voi có thể sửa đổi',
    交易冷却时间: 'Thời gian làm lạnh giao dịch',
    可修改的个人税收: 'Thuế cá nhân có thể sửa đổi',
    真的假的代币: 'Token thật/giả mạo',
    空投骗局: 'Lừa đảo airdrop',
    可以信任: 'Có thể tin cậy',
    业主地址: 'Địa chỉ chủ sở hữu',
    所有者余额: 'Số dư chủ sở hữu',
    业主百分比: 'Phần trăm chủ sở hữu',
    创建者地址: 'Địa chỉ người tạo ra',
    创造者余额: 'Số dư người tạo ra',
    创造者百分比: 'Phần trăm người tạo ra',
    配对持有者: 'Chủ sở hữu cặp',
    其他风险: 'Rủi ro khác',
    注意: 'Chú ý',
    交易: 'Giao dịch',
    dex委托: 'Đặt lệnh SWAP',
    dex历史委托: 'Lịch sử Đặt lệnh SWAP',
    zgj: 'Giá cao nhất:',
    zdj: 'Giá thấp nhất:',
    gflj: 'Liên kết chính thức',
    gw: 'Trang chủ',
    qkllq: 'Trình duyệt khối',
    scfxsj: 'Thời gian phát hành lần đầu',
    fxzl: 'Tổng cung',
    lszl: 'Tổng lưu hành',
    jy: 'Giao dịch',
    sj: 'Giá thị trường',
    tbxx: 'Thông tin biểu đồ',
    bzgk: 'Tổng quan loại tiền',
    jcb: 'Phiên bản cơ bản',
    ddb: 'Bảng đặt hàng',
    zxcj: 'Giao dịch mới nhất',
  
    reload: "Làm mới",
    socketError: "Lỗi mạng, vui lòng",
    noData: "Chưa có dữ liệu",
    entrustorder: "Sổ lệnh",
    prices: "Giá",
    quantity: "Số lượng",
    grandtotal: "Tổng cộng",
    transamount: "Số tiền giao dịch",
    time: "Thời gian",
    available: "Có sẵn",
    limitorder: "Giới hạn giá",
    plancommission: "Lệnh đặt kế hoạch",
    currentcommission: "Lệnh đặt hiện tại",
    historycommission: "Lệnh đặt lịch sử",
    completecommission: "Lệnh đặt đã thực hiện",
    funds: 'Quỹ',
    hidetrading: "Ẩn các cặp giao dịch khác",
    morecurrentcommission: "Thêm lệnh đặt hiện tại",
    morehistorycommission: "Thêm lệnh đặt lịch sử",
    moredocommission: "Thêm lệnh đặt đã thực hiện",
    realtimetrans: "Giao dịch thời gian thực",
    myassets: "Tài sản của tôi",
    detail: "Chi tiết",
    buyin: "Mua vào",
    sellout: "Bán ra",
    login: "Đăng nhập",
    transfer: "Chuyển khoản",
    recharge: "Nạp tiền",
    withdrawal: "Mua tiền",
    quickpurchase: "Mua tiền nhanh chóng qua pháp vị",
    default: "Mặc định",
    ordertime: "Thời gian đặt lệnh",
    windingtime: "Thời gian quấn dây",
    tradingpair: "Cặp giao dịch",
    direction: "Hướng",
    types: "Loại",
    commissionprice: "Giá đặt lệnh",
    commissionnumber: "Số lượng đặt lệnh",
    dealprice: "Giá trung bình giao dịch",
    dealnumber: "Số lượng giao dịch",
    triggerprice: "Giá kích hoạt",
    cancelall: "Hủy toàn bộ lệnh",
    averageprice: "Giá trung bình",
    totalsum: "Tổng cộng",
    fixedprice: "Giá giới hạn",
    marketprice: "Giá thị trường",
    codeExpired: "Mã QR đã hết hạn",
    clickRefresh: "Nhấp để làm mới",
    QRsuccessfully: "Quét mã QR thành công",
    loginInApp: "Vui lòng xác nhận đăng nhập trong ứng dụng",
    backtoQR: "Quay lại đăng nhập bằng mã QR",
    loginSuccess: "Bạn đã đăng nhập thành công, BiKing chào mừng bạn!",
    loadingText: "Đang tải...",
    searchPlaceholder: "Tìm kiếm",
    all: "Tất cả",
    currency: "Loại tiền",
    price: "Giá mới nhất",
    market: "Bảng tăng giảm",
    increase: "Tăng giảm",
    highestPrice: "Giá cao nhất",
    minimumPrice: "Giá thấp nhất",
    turnover: "Khối lượng giao dịch",
    jydlb: "Danh sách cặp giao dịch",
    bzjs: "Giới thiệu loại tiền",
    currencyTransaction: "Giao dịch tiền điện tử",
    leveragedTransaction: "Giao dịch đòn bẩy",
    warning:
      "Cảnh báo rủi ro: Hard Fork Bitcoin Cash mang lại độ không chắc chắn rất lớn. Giao dịch hoặc đầu tư vào token hard fork có rủi ro rất lớn. Nếu một chuỗi không có sự hỗ trợ từ các thợ mỏ, có thể không thể tồn tại, và có rủi ro token liên quan về zero. BiKing không cam kết về giá trị của bất kỳ token hard fork nào! ",
    zb: "Chỉ số",
    date: "Thời gian",
    UpAnddown: "Tăng giảm",
    amplitude: "Biên độ",
    0: "Theo giờ",
    1: "1 phút",
    5: "5 phút",
    15: "15 phút",
    30: "30 phút",
    60: "1 giờ",
    240: "4 giờ",
    3600: "1 ngày",
    10800: "1 tuần",
    dates: "Chu kỳ:",
    password: "Mật khẩu giao dịch",
    errorPassword: "Vui lòng nhập đúng mật khẩu giao dịch",
    worningPassword: "Vui lòng nhập mật khẩu giao dịch",
    cancel: "Hủy bỏ",
    sure: "Chắc chắn",
    canBuy: "Có thể mua",
    canCell: "Có thể bán",
    withdraw: "Rút tiền",
    otc: "OTC, Nạp và rút tiền nhanh chóng bằng tiền mặt",
    enterPrice: "Vui lòng nhập giá",
    sellingPrice: "Giá bán",
    purchasePrice: "Giá mua",
    salesVolume: "Khối lượng bán",
    buyingVolume: "Khối lượng mua",
    volume: "Giá trị giao dịch",
    serviceCharge: "Phí giao dịch",
    vip: "Nâng cấp VIP để nhận chiết khấu phí giao dịch",
    or: "Hoặc",
    register: "Đăng ký",
    totalPrice: "Số tiền giao dịch không được lớn hơn",
    amountTip: "Vui lòng nhập số lượng đúng",
    amountTipError: "Số lượng không được lớn hơn",
    limitTrading: "Giao dịch giới hạn",
    priceReminder: "Nhắc nhở giá",
    SMSReminder: "Nhắc nhở SMS",
    loginAccount: "Tài khoản đăng nhập",
    phone: "Điện thoại",
    phoneNum: "Vui lòng nhập số điện thoại",
    phoneTips: "Vui lòng nhập số điện thoại đúng",
    email: "Email",
    emailNum: "Vui lòng nhập email",
    emailTips: "Vui lòng nhập email đúng",
    aears: "Vui lòng chọn mã vùng",
    passwordError: "Vui lòng nhập mật khẩu đúng",
    passwordTips: "Vui lòng nhập mật khẩu",
    forgetPassword: "Quên mật khẩu",
    noAccount: "Không có tài khoản",
    goRegister: "Đăng ký ngay",
    appsys: "Quét mã QR trong ứng dụng để đăng nhập an toàn",
    xzapp: "Tải ứng dụng mới nhất",
    mmdl: "Đăng nhập mật khẩu",
    smdl: "Quét mã đăng nhập",
    google: "Ứng dụng xác minh Google",
    nybd: "Bạn đã liên kết",
    zqyzm: "Vui lòng nhập mã xác minh đúng",
    fsyzm: "Gửi mã xác minh",
    flv: "Phí giao dịch",
    jz: "Giá trị ròng",
    jzdesc1:
      "Giá trị ròng khi đoán giảm giá = Giá trị ròng khi điều chỉnh lần trước *[1+3*(Giá giao dịch mới nhất - Giá khi điều chỉnh lần trước)/Giá khi điều chỉnh lần trước*100%]；",
    jzdesc2:
      "Giá trị ròng khi đoán tăng giá = Giá trị ròng khi điều chỉnh lần trước *[1-3*(Giá giao dịch mới nhất - Giá khi điều chỉnh lần trước)/Giá khi điều chỉnh lần trước*100%]；",
    sbd: "3 lần giảm giá",
    sbs: "3 lần tăng giá",
    flvjs:
      'Phí giao dịch ETF là khoản phí quản lý mỗi ngày do nền tảng thu thập theo tỷ lệ tương ứng của đòn bẩy, để thanh toán phí giao dịch tạo ra từ quản lý quỹ. Phí quản lý sẽ phản ánh trong giá trị ròng, tức là sẽ được thể hiện dưới dạng "trừ đi giá trị tương ứng của ETF đòn bẩy" và chỉ thu vào 0 giờ giờ Singapore, nếu bạn không giữ sản phẩm vào thời điểm đó, bạn sẽ không phải trả phí.',
    mzsm: "Tuyên bố từ chối trách nhiệm",
    ido: "Tôi đã đọc và đồng ý với",
    exemption1: "Kính thưa quý khách hàng!",
    exemption2:
      "Cảm ơn quý khách đã đăng nhập và sử dụng các sản phẩm ETF công cộng và dịch vụ liên quan mà BiKing Platform (BiKing.ai) cung cấp (gọi tắt là “sản phẩm ETF”). Vui lòng đọc kỹ Hướng dẫn Sản phẩm ETF và các cảnh báo rủi ro dưới đây. Nếu bạn tiếp tục sử dụng Sản phẩm ETF sau khi đọc, điều này có nghĩa là bạn đã hiểu rõ và đồng ý với tất cả các rủi ro của Sản phẩm ETF, có khả năng chịu được mất mát có thể phát sinh khi sử dụng Sản phẩm ETF và bạn đã đồng ý với toàn bộ nội dung của Tuyên bố từ chối trách nhiệm này. Vui lòng nhấp vào đây để đọc Hướng dẫn Sản phẩm ETF:",
    exemption3: "《Câu hỏi thường gặp về sản phẩm ETF đòn bẩy》",
    exemption4: "Cảnh báo rủi ro:",
    exemption5:
      "1. Giá mua/bán của bạn không nên chênh lệch quá nhiều so với giá trị ròng đơn vị, nếu không bạn có thể phải chịu mất lỗ tương ứng.",
    exemption6:
      "2. Nếu đánh giá hướng sai, có rủi ro giá gần bằng không trong điều kiện thị trường cực kỳ.",
    exemption7:
      "BiKing Platform xin nhắc nhở một cách nghiêm túc rằng mọi tổn thất hoặc trách nhiệm phát sinh do rủi ro nêu trên đều thuộc trách nhiệm của bạn. BiKing Platform không chịu trách nhiệm về điều này. Tuyên bố từ chối trách nhiệm này cùng với các hiệp ước, tuyên bố và quy tắc khác trong BiKing Platform, cùng nhau tạo nên toàn bộ thỏa thuận giữa BiKing Platform và bạn về dịch vụ và sản phẩm của BiKing Platform.",
    bzjs1: "1. '3L' biểu thị giảm giá 1%, giá trị ròng của sản phẩm tăng 3%.",
    bzjs2: "2. '3S' biểu thị tăng giá 1%, giá trị ròng của sản phẩm tăng 3%.",
    bzjs3: "3. Giá trị ròng sẽ được điều chỉnh hằng ngày lúc 0:00, và sẽ được điều chỉnh trong phiên đối với tình huống thị trường cực đoan.",
    bzjs4: "4. Mỗi đòn bẩy sẽ thu phí quản lý tương ứng mỗi ngày.",
    bzjs5:
      "5. Trước khi giao dịch, hãy chú ý đến giá trị ròng. Sản phẩm này có rủi ro giá gần bằng không trong tình huống thị trường cực đoan, có rủi ro giá rất xa rời khỏi giá trị ròng, vui lòng kiểm soát rủi ro.",
    gdjk: "Xem thêm thông tin chi tiết trong thông báo",
    firstTrading: "Trước giao dịch lần đầu, vui lòng thiết lập mật khẩu giao dịch",
    status: "Trạng thái",
    status1: "Chờ khớp lệnh",
    status2: "Chưa thực hiện giao dịch",
    status3: "Người dùng hủy bỏ",
    status4: "Một phần đã thực hiện",
    status5: "Thực hiện đầy đủ",
    status6: "Không hợp lệ",
    allCancel: "Hủy tất cả lệnh đặt",
    canceld: "Hủy bỏ",
    cancelsuccess: "Hủy bỏ tất cả lệnh thành công, đã hủy bỏ [*] lệnh đặt",
    VIP1: "Hạng VIP của bạn",
    VIP2: "Phí giao dịch thấp hơn, trải nghiệm giao dịch tốt hơn",
    VIP3: "Taker (Lệnh thị trường):",
    VIP4: "Maker (Lệnh giới hạn):",
    buyAmount: "Số lượng mua không được lớn hơn",
    sellAmount: "Số lượng bán không được lớn hơn",
    buyAmountMin: "Số dư mua của bạn không đủ",
    sellAmountMin: "Số dư bán của bạn không đủ",
}


// WEBPACK FOOTER //
// ./src/i18n/lang/trading1/vi.js